<template>
  <v-container fluid grid-list-md style="padding: 30px;">
    <v-data-table :search="search" v-if="!addUser" :headers="headers" :items="empresas" sort-desc class="elevation-1" style="border-radius: 10px;">
      <template v-slot:top>
        <v-toolbar flat color="white" style="border-radius: 10px;">
          <v-toolbar-title class="textoUser">EMPRESAS</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Pesquisa" single-line hide-details></v-text-field>
          <v-spacer></v-spacer>
          <!-- <form ref="myform" action="confirmarPagamento" method="POST"></form> -->
          <v-btn text @click="dialogInicialReplicar" tile color="#4A148C">
            <v-icon left dark>add_circle</v-icon> Nova empresa
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-icon @click="editItem(item)">edit</v-icon>
        <v-icon medium @click="deleteItem(item)" v-if="companyobj.agenda || companyobj.vigilante">delete</v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="#7B1FA2" @click="carregaDados">Recarregar</v-btn>
      </template>
    </v-data-table>

    <!-- CARD INSERE USUARIOS -->
    <v-card v-else style="border-radius: 10px;">
      <template v-if=" adicionarEvento">
        <v-card-title>
          <span class="textoUser">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <p style="font-size:15px; color:#7B1FA2"> *O preenchimento de todos os campos é obrigatório</p>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.nome" outlined label="Nome" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.cnpj" outlined label="CNPJ" v-mask="'##.###.###/####-##'" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.endereco" outlined label="Endereço" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.telefone" outlined label="Telefone" v-mask="'(##) #####-####'" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.email" outlined label="E-mail" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.capacidade" outlined label="Capacidade" color="#7B1FA2" type="number"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.logoUrl" outlined label="URL do Logo" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.avatarUrl" outlined label="URL do Avatar" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.linkVendas" outlined label="Link de Vendas" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.porcentagem" outlined label="Porcentagem" color="#7B1FA2" type="number"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.eventosLiberados" outlined label="Eventos Liberados" color="#7B1FA2" type="number"></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-divider></v-divider>
                <h3 class="mt-3 mb-3">Configurações de Crédito</h3>
              </v-col>
              
              <v-col cols="12" sm="3" md="3">
                <v-text-field v-model="editedItem.creditoFaixa.faixa1" outlined label="Crédito Faixa 1" color="#7B1FA2" type="number"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-text-field v-model="editedItem.creditoFaixa.faixa2" outlined label="Crédito Faixa 2" color="#7B1FA2" type="number"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-text-field v-model="editedItem.creditoFaixa.faixa3" outlined label="Crédito Faixa 3" color="#7B1FA2" type="number"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-text-field v-model="editedItem.creditoFaixa.faixa4" outlined label="Crédito Faixa 4" color="#7B1FA2" type="number"></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-divider></v-divider>
                <h3 class="mt-3 mb-3">Configurações de Comunicação</h3>
              </v-col>

              <v-col cols="12" sm="4" md="4">
                <v-checkbox v-model="editedItem.enviaWhatspp" label="Envia WhatsApp"></v-checkbox>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-checkbox v-model="editedItem.enviaSMS" label="Envia SMS"></v-checkbox>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-checkbox v-model="editedItem.enviaEmail" label="Envia Email"></v-checkbox>
              </v-col>

              <v-col cols="12" sm="6" md="6">
                <v-select v-model="editedItem.apiWhatsApp" outlined label="API WhatsApp" :items="['ZAPI', 'ZADI']" color="#7B1FA2"></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.tokenWhatsApp" outlined label="Token WhatsApp" color="#7B1FA2"></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="6" v-if="editedItem.apiWhatsApp === 'ZAPI'">
                <v-text-field v-model="editedItem.zapiClientToken" outlined label="ZAPI Client Token" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="editedItem.apiWhatsApp === 'ZAPI'">
                <v-text-field v-model="editedItem.zapiInstanciaID" outlined label="ZAPI Instância ID" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="editedItem.apiWhatsApp === 'ZAPI'">
                <v-text-field v-model="editedItem.zapiInstanciaToken" outlined label="ZAPI Instância Token" color="#7B1FA2"></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-divider></v-divider>
                <h3 class="mt-3 mb-3">Configurações de Pagamento</h3>
              </v-col>

              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.gatewayPagamentoPix" outlined label="Gateway de Pagamento" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.idAsaas" outlined label="ID ASAAS" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="editedItem.tokenAsaas" outlined label="Token ASAAS" color="#7B1FA2"></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="6" v-if="editedItem.gatewayPagamentoPix === 'SICOOB'">
                <v-text-field v-model="editedItem.sicoobClientId" outlined label="SICOOB Client ID" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="editedItem.gatewayPagamentoPix === 'SICOOB'">
                <v-text-field v-model="editedItem.sicoobChavePix" outlined label="SICOOB Chave PIX" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="editedItem.gatewayPagamentoPix === 'SICOOB'">
                <v-text-field v-model="editedItem.arquivoPfx" outlined label="Arquivo PFX" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="editedItem.gatewayPagamentoPix === 'SICOOB'">
                <v-text-field v-model="editedItem.passphrase" outlined label="Passphrase" color="#7B1FA2"></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="6" v-if="editedItem.gatewayPagamentoPix === 'TAPAGO'">
                <v-text-field v-model="editedItem.taPagoClientId" outlined label="TáPago Client ID" color="#7B1FA2" type="number"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="editedItem.gatewayPagamentoPix === 'TAPAGO'">
                <v-text-field v-model="editedItem.taPagoClientSecret" outlined label="TáPago Client Secret" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="editedItem.gatewayPagamentoPix === 'TAPAGO'">
                <v-text-field v-model="editedItem.taPagoAccountId" outlined label="TáPago Account ID" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="editedItem.gatewayPagamentoPix === 'TAPAGO'">
                <v-text-field v-model="editedItem.taPagoAlias" outlined label="TáPago Alias" color="#7B1FA2"></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-divider></v-divider>
                <h3 class="mt-3 mb-3">Mensagens de Confirmação</h3>
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <v-textarea v-model="editedItem.msgConfirmacaoPagamento" outlined label="Mensagem de Confirmação de Pagamento" color="#7B1FA2" rows="4"></v-textarea>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-textarea v-model="editedItem.msgConfirmacaoGratuito" outlined label="Mensagem de Confirmação para Evento Gratuito" color="#7B1FA2" rows="4"></v-textarea>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-textarea v-model="editedItem.msgConfirmacaoGratuitoSMS" outlined label="Mensagem de Confirmação SMS" color="#7B1FA2" rows="2"></v-textarea>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="editedItem.urlImgConfirmacaoPagamento" outlined label="URL da Imagem de Confirmação" color="#7B1FA2"></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-divider></v-divider>
                <h3 class="mt-3 mb-3">Configuração de Setores</h3>
              </v-col>

              <v-col cols="12" sm="6" md="6">
                <v-select v-model="editedItem.limiteInscricao" outlined label="Limite de Inscrição" :items="['SETOR', 'GLOBAL']" color="#7B1FA2"></v-select>
              </v-col>

              <template v-if="editedItem.setores && editedItem.setores.length > 0">
                <v-col cols="12" v-for="(setor, i) in editedItem.setores" :key="i">
                  <v-row>
                    <v-col cols="12" sm="4" md="4">
                      <v-text-field v-model="setor.nome" outlined label="Nome do Setor" color="#7B1FA2"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                      <v-text-field v-model="setor.limite" outlined label="Limite do Setor" color="#7B1FA2" type="number"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                      <v-color-picker v-model="setor.cor" hide-canvas hide-inputs show-swatches swatches-max-height="100px"></v-color-picker>
                    </v-col>
                    <v-col cols="12" sm="1" md="1">
                      <v-btn icon @click="removerSetor(i)" color="error"><v-icon>delete</v-icon></v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </template>

              <v-col cols="12">
                <v-btn color="success" @click="adicionarSetor">Adicionar Setor</v-btn>
              </v-col>

              <v-col cols="12">
                <v-divider></v-divider>
                <h3 class="mt-3 mb-3">Outras Configurações</h3>
              </v-col>

              <v-col cols="12" sm="6" md="6">
                <v-checkbox v-model="editedItem.vigilante" label="Empresa de Vigilante"></v-checkbox>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.urlCartaoConsumo" outlined label="URL Cartão Consumo" color="#7B1FA2"></v-text-field>
              </v-col>

            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#4A148C" class="cssBotao" dark large @click="save">Salvar</v-btn>
          <v-btn color="#BA68C8" max-width="" class="cssBotao" large dark @click="close">Cancelar</v-btn>
        </v-card-actions>
      </template>

      <template v-if="!adicionarEvento">
        <v-card-title>
          <span class="textoUser">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <p style="font-size:15px; color:#7B1FA2"> *O preenchimento dos campos obrigatórios é necessário</p>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.nome" outlined label="Nome" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.cnpj" outlined label="CNPJ" v-mask="'##.###.###/####-##'" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.endereco" outlined label="Endereço" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.telefone" outlined label="Telefone" v-mask="'(##) #####-####'" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.email" outlined label="E-mail" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.capacidade" outlined label="Capacidade" color="#7B1FA2" type="number"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.logoUrl" outlined label="URL do Logo" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.avatarUrl" outlined label="URL do Avatar" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.linkVendas" outlined label="Link de Vendas" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.porcentagem" outlined label="Porcentagem" color="#7B1FA2" type="number"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.eventosLiberados" outlined label="Eventos Liberados" color="#7B1FA2" type="number"></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-divider></v-divider>
                <h3 class="mt-3 mb-3">Configurações de Crédito</h3>
              </v-col>
              
              <v-col cols="12" sm="3" md="3">
                <v-text-field v-model="editedItem.creditoFaixa.faixa1" outlined label="Crédito Faixa 1" color="#7B1FA2" type="number"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-text-field v-model="editedItem.creditoFaixa.faixa2" outlined label="Crédito Faixa 2" color="#7B1FA2" type="number"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-text-field v-model="editedItem.creditoFaixa.faixa3" outlined label="Crédito Faixa 3" color="#7B1FA2" type="number"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-text-field v-model="editedItem.creditoFaixa.faixa4" outlined label="Crédito Faixa 4" color="#7B1FA2" type="number"></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-divider></v-divider>
                <h3 class="mt-3 mb-3">Configurações de Comunicação</h3>
              </v-col>

              <v-col cols="12" sm="4" md="4">
                <v-checkbox v-model="editedItem.enviaWhatspp" label="Envia WhatsApp"></v-checkbox>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-checkbox v-model="editedItem.enviaSMS" label="Envia SMS"></v-checkbox>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-checkbox v-model="editedItem.enviaEmail" label="Envia Email"></v-checkbox>
              </v-col>

              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.apiWhatsApp" outlined label="API WhatsApp" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.tokenWhatsApp" outlined label="Token WhatsApp" color="#7B1FA2"></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="6" v-if="editedItem.apiWhatsApp === 'ZAPI'">
                <v-text-field v-model="editedItem.zapiClientToken" outlined label="ZAPI Client Token" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="editedItem.apiWhatsApp === 'ZAPI'">
                <v-text-field v-model="editedItem.zapiInstanciaID" outlined label="ZAPI Instância ID" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="editedItem.apiWhatsApp === 'ZAPI'">
                <v-text-field v-model="editedItem.zapiInstanciaToken" outlined label="ZAPI Instância Token" color="#7B1FA2"></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-divider></v-divider>
                <h3 class="mt-3 mb-3">Configurações de Pagamento</h3>
              </v-col>

              <v-col cols="12" sm="6" md="6">
                <v-select v-model="editedItem.gatewayPagamentoPix" outlined label="Gateway de Pagamento" :items="['SICOOB', 'ASAAS', 'TAPAGO']" color="#7B1FA2"></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.idAsaas" outlined label="ID ASAAS" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="editedItem.tokenAsaas" outlined label="Token ASAAS" color="#7B1FA2"></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="6" v-if="editedItem.gatewayPagamentoPix === 'SICOOB'">
                <v-text-field v-model="editedItem.sicoobClientId" outlined label="SICOOB Client ID" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="editedItem.gatewayPagamentoPix === 'SICOOB'">
                <v-text-field v-model="editedItem.sicoobChavePix" outlined label="SICOOB Chave PIX" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="editedItem.gatewayPagamentoPix === 'SICOOB'">
                <v-text-field v-model="editedItem.arquivoPfx" outlined label="Arquivo PFX" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="editedItem.gatewayPagamentoPix === 'SICOOB'">
                <v-text-field v-model="editedItem.passphrase" outlined label="Passphrase" color="#7B1FA2"></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="6" v-if="editedItem.gatewayPagamentoPix === 'TAPAGO'">
                <v-text-field v-model="editedItem.taPagoClientId" outlined label="TáPago Client ID" color="#7B1FA2" type="number"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="editedItem.gatewayPagamentoPix === 'TAPAGO'">
                <v-text-field v-model="editedItem.taPagoClientSecret" outlined label="TáPago Client Secret" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="editedItem.gatewayPagamentoPix === 'TAPAGO'">
                <v-text-field v-model="editedItem.taPagoAccountId" outlined label="TáPago Account ID" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="editedItem.gatewayPagamentoPix === 'TAPAGO'">
                <v-text-field v-model="editedItem.taPagoAlias" outlined label="TáPago Alias" color="#7B1FA2"></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-divider></v-divider>
                <h3 class="mt-3 mb-3">Mensagens de Confirmação</h3>
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <v-textarea v-model="editedItem.msgConfirmacaoPagamento" outlined label="Mensagem de Confirmação de Pagamento" color="#7B1FA2" rows="4"></v-textarea>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-textarea v-model="editedItem.msgConfirmacaoGratuito" outlined label="Mensagem de Confirmação para Evento Gratuito" color="#7B1FA2" rows="4"></v-textarea>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-textarea v-model="editedItem.msgConfirmacaoGratuitoSMS" outlined label="Mensagem de Confirmação SMS" color="#7B1FA2" rows="2"></v-textarea>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="editedItem.urlImgConfirmacaoPagamento" outlined label="URL da Imagem de Confirmação" color="#7B1FA2"></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-divider></v-divider>
                <h3 class="mt-3 mb-3">Configuração de Setores</h3>
              </v-col>

              <v-col cols="12" sm="6" md="6">
                <v-select v-model="editedItem.limiteInscricao" outlined label="Limite de Inscrição" :items="['SETOR']" color="#7B1FA2"></v-select>
              </v-col>

              <template v-if="editedItem.setores && editedItem.setores.length > 0">
                <v-col cols="12" v-for="(setor, i) in editedItem.setores" :key="i">
                  <v-row>
                    <v-col cols="12" sm="4" md="4">
                      <v-text-field v-model="setor.nome" outlined label="Nome do Setor" color="#7B1FA2"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                      <v-text-field v-model="setor.limite" outlined label="Limite do Setor" color="#7B1FA2" type="number"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                      <v-color-picker v-model="setor.cor" hide-canvas hide-inputs show-swatches swatches-max-height="100px"></v-color-picker>
                    </v-col>
                    <v-col cols="12" sm="1" md="1">
                      <v-btn icon @click="removerSetor(i)" color="error"><v-icon>delete</v-icon></v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </template>

              <v-col cols="12">
                <v-btn color="success" @click="adicionarSetor">Adicionar Setor</v-btn>
              </v-col>

              <v-col cols="12">
                <v-divider></v-divider>
                <h3 class="mt-3 mb-3">Outras Configurações</h3>
              </v-col>

              <v-col cols="12" sm="6" md="6">
                <v-checkbox v-model="editedItem.vigilante" label="Empresa de Vigilante"></v-checkbox>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.urlCartaoConsumo" outlined label="URL Cartão Consumo" color="#7B1FA2"></v-text-field>
              </v-col>

            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#4A148C" class="cssBotao" dark large @click="save">Salvar</v-btn>
          <v-btn color="#BA68C8" max-width="" class="cssBotao" large dark @click="close">Cancelar</v-btn>
        </v-card-actions>
      </template>

      <v-dialog v-else v-model="dialog" max-width="500px" persistent>
        <v-card light>
          <v-card-title>
            <span class="textoUser">NOVA EMPRESA</span>
          </v-card-title>
          <v-container>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-text-field v-model="editedItem.nome" outlined label="Nome da Empresa" color="#7B1FA2"></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-text-field v-model="editedItem.cnpj" v-mask="'##.###.###/####-##'" outlined label="CNPJ" color="#7B1FA2"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#4A148C" class="cssBotao" dark large @click="avancarReplicar()">Avançar</v-btn>
            <v-btn color="#BA68C8" max-width="" class="cssBotao" large dark @click="close">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>

    <loading :active.sync="isLoading" :can-cancel="true" color="#7B1FA2" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  // import moment from 'moment'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    components: { Snackbar, Loading },
    data: () => ({
      fullPage: true,
      isLoading: false,
      limitado: true,
      faixas: [],
      search: '',
      addUser: false,
      dialog: false,
      dialogReplicarEvento: false,
      adicionarEvento: false,
      checkbox1: false,
      eventosCadastrados: [],
      tipoSelecionado: '',
      id_evento: '',
      temInscritos: false,
      exigePagamento: [
        { text: 'SIM', value: true, },
        { text: 'NÃO', value: false, },
      ],
      headers: [
        { text: 'Nome', align: 'start', value: 'nome', },
        { text: 'CNPJ', value: 'cnpj' },
        { text: 'Endereço', value: 'endereco' },
        { text: 'Telefone', value: 'telefone' },
        { text: 'Link Vendas', value: 'linkVendas' },
        { text: 'Capacidade', align: 'center', value: 'capacidade' },
        { text: 'Ações', value: 'action', align: 'center', sortable: false },
      ],
      qualificacoes: ['APOIO', 'VIGILANTE BÁSICO', 'VIGILANTE DE GRANDES EVENTOS'],
      empresas: [],
      editedIndex: -1,
      editedItem: {
        nome: '',
        cnpj: '',
        endereco: '',
        telefone: '',
        logoUrl: '',
        avatarUrl: '',
        email: '',
        capacidade: 100,
        creditoFaixa: {
          faixa1: 0,
          faixa2: 0,
          faixa3: 0,
          faixa4: 0
        },
        linkVendas: '',
        enviaWhatspp: true,
        enviaSMS: false,
        enviaEmail: false,
        idAsaas: '',
        tokenAsaas: '',
        eventosLiberados: 4,
        porcentagem: 100,
        msgConfirmacaoPagamento: 'seu pagamento para *{NOME EVENTO}* foi *APROVADO!*\r\n\r\nClique no link abaixo para ter acesso ao seu ingresso digital:\r\nhttps://aicheckin.com.br/{linkVendas}?cod={codIncricao}\r\n\r\nObs.: caso o link não esteja clicável, será necessário salvar nosso contato em sua agenda primeiro.',
        msgConfirmacaoGratuito: 'sua inscrição para *{NOME EVENTO}* foi *REGISTRADA!* com sucesso!\r\n\r\nClique no link abaixo para ter acesso ao seu ingresso digital:\r\nhttps://aicheckin.com.br/{linkVendas}?cod={codIncricao}\r\n\r\nObs.: caso o link não esteja clicável, será necessário salvar nosso contato em sua agenda primeiro.',
        msgConfirmacaoGratuitoSMS: '',
        urlImgConfirmacaoPagamento: '',
        tokenWhatsApp: '',
        gatewayPagamentoPix: '',
        taPagoClientId: 0,
        taPagoClientSecret: '',
        taPagoAccountId: '',
        taPagoAlias: '',
        sicoobClientId: '',
        arquivoPfx: '',
        passphrase: '',
        sicoobChavePix: '',
        limiteInscricao: 'SETOR',
        setores: [
          {
            nome: 'ÚNICO',
            limite: 1000,
            cor: '#0800ff'
          }
        ],
        apiWhatsApp: '',
        zapiClientToken: '',
        zapiInstanciaID: '',
        zapiInstanciaToken: '',
        vigilante: false,
        urlCartaoConsumo: ''
      },
      inscricoesItem: [{
        cod_incricao: '',
        nome: '',
        cpf: '',
        sexo: '',
        telefone: '',
        tipo: '',
        eventoId: '',
        checkin: '',
        checkout: '',
      }],
      defaultItem: {
        nome: '',
        cnpj: '',
        endereco: '',
        telefone: '',
        logoUrl: '',
        avatarUrl: '',
        email: '',
        capacidade: 100,
        creditoFaixa: {
          faixa1: 0,
          faixa2: 0,
          faixa3: 0,
          faixa4: 5
        },
        linkVendas: '',
        enviaWhatspp: true,
        enviaSMS: false,
        enviaEmail: false,
        idAsaas: '',
        tokenAsaas: '',
        eventosLiberados: 4,
        porcentagem: 100,
        msgConfirmacaoPagamento: '',
        msgConfirmacaoGratuito: '',
        msgConfirmacaoGratuitoSMS: '',
        urlImgConfirmacaoPagamento: '',
        tokenWhatsApp: '',
        gatewayPagamentoPix: '',
        taPagoClientId: 0,
        taPagoClientSecret: '',
        taPagoAccountId: '',
        taPagoAlias: '',
        sicoobClientId: '',
        arquivoPfx: '',
        passphrase: '',
        sicoobChavePix: '',
        limiteInscricao: 'SETOR',
        setores: [
          {
            nome: 'ÚNICO',
            limite: 1000,
            cor: '#0800ff'
          }
        ],
        apiWhatsApp: '',
        zapiClientToken: '',
        zapiInstanciaID: '',
        zapiInstanciaToken: '',
        vigilante: false,
        urlCartaoConsumo: ''
      },
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle() {
        return this.editedIndex === -1 ? 'ADICIONAR NOVA EMPRESA ' : 'EDITAR EMPRESA'
      }
    }),

    created() {

    },

    mounted() {
      this.carregaDados()
    },

    watch: {
      search: function() {
        this.carregaDados()
      }
    },

    methods: {
      async carregaDados() {
        this.isLoading = true
        await axios.get(`${baseApiUrl}Empresas?access_token=${sessionStorage.getItem('accToken')}`)
        .then(res => {
          if (res.data != '') {
            this.empresas = res.data
            }
          this.isLoading = false
        })
      },

      formatDate(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDateBrz(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePadrao(date) {
        if (!date) return null

        const [day, month, year] = date.substr(0, 10).split('/')
        return `${year}-${month}-${day}` + " " + date.substr(11, 6)
      },

      formatDateHora(date) {
        if (!date) return null

        const [year, month, day] = date.substr(0, 10).split('-')
        return `${day}/${month}/${year}` + " " + date.substr(11, 8)
      },

      openDialog() {
        this.dialog = true
      },

      editItem(item) {
        this.editedIndex = this.empresas.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.adicionarEvento = false
        this.addUser = true
      },

      async deleteItem(item) {
        var r = confirm('Deseja realmente excluir a Empresa: ' + item.nome + '?')
        if (r == true) {
          this.isLoading = true
          await axios.delete(`${baseApiUrl}Empresas/${item.id}?access_token=${sessionStorage.getItem('accToken')}`)
          .then(() => {
            this.isLoading = false
            var vm = this
            vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
            this.carregaDados()
          })
        }
      },

      close() {
        this.dialogReplicarEvento = false
        this.addUser = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      async save() {
        this.isLoading = true
        
        // Ensure capacidade is a number
        this.editedItem.capacidade = parseInt(this.editedItem.capacidade)
        
        // Ensure creditoFaixa values are numbers
        if (this.editedItem.creditoFaixa) {
          this.editedItem.creditoFaixa.faixa1 = parseInt(this.editedItem.creditoFaixa.faixa1) || 0
          this.editedItem.creditoFaixa.faixa2 = parseInt(this.editedItem.creditoFaixa.faixa2) || 0
          this.editedItem.creditoFaixa.faixa3 = parseInt(this.editedItem.creditoFaixa.faixa3) || 0
          this.editedItem.creditoFaixa.faixa4 = parseInt(this.editedItem.creditoFaixa.faixa4) || 0
        }
        
        // Ensure porcentagem is a number
        this.editedItem.porcentagem = parseInt(this.editedItem.porcentagem)
        
        // Ensure eventosLiberados is a number
        this.editedItem.eventosLiberados = parseInt(this.editedItem.eventosLiberados)
        
        // Ensure each setor has a numerical limite
        if (this.editedItem.setores && this.editedItem.setores.length > 0) {
          this.editedItem.setores.forEach(setor => {
            setor.limite = parseInt(setor.limite) || 1000
          })
        }
        
        if (this.editedIndex != -1) {
          await axios.patch(`${baseApiUrl}Empresas/${this.editedItem.id}?access_token=${sessionStorage.getItem('accToken')}`, this.editedItem)
          .then(res => {
            if (res.data != null) {
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
              this.carregaDados()
            }
          }).catch(() => {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
          })
        } else {
          await axios.post(`${baseApiUrl}Empresas?access_token=${sessionStorage.getItem('accToken')}`, this.editedItem)
            .then(res => {
              if (res.data != null) {
                var vm = this;
                vm.$refs.chamaSnackbar.snack("#0288D1", "Empresa cadastrada com sucesso!", "INFORMAÇÃO")
                this.carregaDados()
              }
            }).catch(() => {
              this.isLoading = false
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao cadastrar empresa, tente novamente", "ERRO")
            })
        }
        this.isLoading = false
        this.close()
      },

      adicionarSetor() {
        if (!this.editedItem.setores) {
          this.editedItem.setores = []
        }
        this.editedItem.setores.push({
          nome: '',
          limite: 500,
          cor: '#' + Math.floor(Math.random()*16777215).toString(16) // Gera uma cor aleatória
        })
      },

      removerSetor(index) {
        if (this.editedItem.setores.length > 1) {
          this.editedItem.setores.splice(index, 1)
        } else {
          var vm = this
          vm.$refs.chamaSnackbar.snack("#F9A825", "É necessário ter pelo menos um setor!", "ATENÇÃO")
        }
      },

      dialogInicialReplicar() {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.dialog = true
        this.adicionarEvento = false
        this.addUser = true
      },

      async verificaDisponibilidade() {
        var creditoFaixa = []
        this.faixas = []
        await axios.get(`${baseApiUrl}Empresas?filter[where][id]=${this.companyobj.id}&access_token=${this.token}`)
          .then(res => {
            creditoFaixa = res.data[0].creditoFaixa
          })
        if (creditoFaixa.faixa1 != 0) {
          this.limitado = true
          this.faixas.push(30)
          this.addUser = true
        }
        if (creditoFaixa.faixa2 != 0) {
          this.limitado = true
          this.faixas.push(60)
          this.addUser = true
        }
        if (creditoFaixa.faixa3 != 0) {
          this.limitado = true
          this.faixas.push(100)
          this.addUser = true
        }
        if (creditoFaixa.faixa4 != 0) {
          this.limitado = false
          this.addUser = true
        }
        if (creditoFaixa.faixa1 == 0 && creditoFaixa.faixa2 == 0 && creditoFaixa.faixa3 == 0 && creditoFaixa.faixa4 == 0) {
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825", "Você não possui créditos para a inclusão de um novo evento, entre em contato com a Intelite e solicite agora!", "ATENÇÃO")
        }
      },

      avancarReplicar() {
        if (!this.editedItem.nome) {
          var vm = this
          vm.$refs.chamaSnackbar.snack("#F9A825", "Nome da empresa é obrigatório!", "ATENÇÃO")
          return
        }
        
        this.adicionarEvento = true
        this.dialog = false
      }
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px;
    width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }
</style>